/* Creative Velas — pedido para bodas y eventos.
   Servicio mínimo fijo (o preparación del pedido si recoge el cliente) + segundo día opcional + piezas a la carta.
   Las solicitudes se envían por el formulario de contacto nativo.
   Las compras (si hubiera productos de compra) usan el carrito nativo de Shopify (/cart/add.js → checkout). */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // Textos por idioma: vienen del JSON [data-eo-i18n] que genera la sección con las claves cv.eo.*.
  var FALLBACK = {
    add: 'Añadir al pedido', no_event: 'Aún no has indicado los datos del evento.', rental: 'Alquiler', buy: 'Compra',
    remove_one: 'Quitar una unidad', add_one: 'Añadir una unidad', send_booking: 'Enviar solicitud de reserva', pay: 'Ir al pago seguro',
    unavailable: 'No disponible', added: 'Añadido ✓', in_order_one: 'En tu pedido: 1 unidad', in_order_other: 'En tu pedido: %n unidades',
    phrase: 'Frase', buy_lc: 'compra', rental_lc: 'alquiler', on_request: 'A consultar', on_request_lc: 'a consultar',
    guests: '%n invitados', subtotal: 'subtotal', fill_event: 'Indica el tipo de evento y la fecha en el paso 1.',
    estimated_total: 'Total orientativo:', plus_on_request: '+ piezas a consultar',
    send_and_cart: 'Enviar solicitud y guardar compra en el carrito', preparing: 'Preparando el pago…',
    cart_error: 'No se ha podido añadir al carrito.', delete: 'Eliminar'
  };
  // El filtro `t` de Liquid escapa los caracteres HTML (por ejemplo ' -> &#39;).
  // Como estos textos se pintan con textContent, hay que deshacer ese escape.
  function decodeEntities(s) {
    if (s.indexOf('&') === -1) return s;
    var ta = document.createElement('textarea');
    ta.innerHTML = s;
    return ta.value;
  }
  function readI18n(root) {
    var out = {}, k, data = {};
    var el = root.querySelector('[data-eo-i18n]');
    if (el) { try { data = JSON.parse(el.textContent) || {}; } catch (e) { data = {}; } }
    for (k in FALLBACK) {
      var v = data[k];
      out[k] = (typeof v === 'string' && v && v.indexOf('translation missing') === -1) ? decodeEntities(v) : FALLBACK[k];
    }
    return out;
  }

  function Order(root) {
    this.root = root;
    this.key = root.getAttribute('data-storage-key');
    this.persoProp = root.getAttribute('data-perso-prop') || 'Frase personalizada';
    this.currency = root.getAttribute('data-currency') || 'EUR';
    // El alquiler se muestra siempre como "150,00 €" (formato del resto de la página), no con el formato de la tienda.
    this.moneyFormat = '';
    this.locale = root.getAttribute('data-locale') || 'es';
    var bp = root.getAttribute('data-base-price');
    this.base = (bp !== null && bp !== '' && !isNaN(parseInt(bp, 10)))
      ? { price: parseInt(bp, 10), name: root.getAttribute('data-base-name') || 'Servicio mínimo' }
      : null;
    var dp = root.getAttribute('data-day-price');
    this.extraDay = (dp !== null && dp !== '' && !isNaN(parseInt(dp, 10)))
      ? { price: parseInt(dp, 10), name: root.getAttribute('data-day-name') || 'Segundo día de alquiler' }
      : null;
    var fp = root.getAttribute('data-fee-price');
    this.fee = (fp !== null && fp !== '' && !isNaN(parseInt(fp, 10)))
      ? { price: parseInt(fp, 10), name: root.getAttribute('data-fee-name') || 'Preparación del pedido' }
      : null;
    this.modeService = root.getAttribute('data-mode-service') || '';
    this.modePickup = root.getAttribute('data-mode-pickup') || '';
    this.t = readI18n(root);
    try { this.fmt = new Intl.NumberFormat(this.locale, { style: 'currency', currency: this.currency }); }
    catch (e) { this.fmt = new Intl.NumberFormat('es-ES', { style: 'currency', currency: this.currency }); }
    this.state = this.load();
    this.cards = Array.prototype.slice.call(root.querySelectorAll('[data-eo-item]'));
    this.q = function (sel) { return root.querySelector(sel); };
    this.qa = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
    this.init();
  }

  Order.prototype.load = function () {
    var empty = { event: { type: '', date: '', guests: '', days: '1', mode: 'service' }, lines: [] };
    try {
      var raw = window.localStorage.getItem(this.key);
      if (!raw) return empty;
      var s = JSON.parse(raw);
      if (!s || !Array.isArray(s.lines)) return empty;
      s.event = s.event || empty.event;
      if (s.event.days !== '2') s.event.days = '1';
      if (s.event.mode !== 'pickup') s.event.mode = 'service';
      return s;
    } catch (e) { return empty; }
  };

  Order.prototype.save = function () {
    try { window.localStorage.setItem(this.key, JSON.stringify(this.state)); } catch (e) {}
  };

  Order.prototype.pickup = function () { return !!this.modePickup && this.state.event.mode === 'pickup'; };
  Order.prototype.modeLabel = function (mode) { return mode === 'pickup' ? this.modePickup : this.modeService; };

  // Líneas fijas: servicio mínimo (con servicio) o preparación del pedido (si el cliente recoge él mismo el material)
  // y segundo día si se elige. Solo existen mientras haya alguna pieza en el pedido y no se pueden quitar ni cambiar de cantidad.
  Order.prototype.ensureBase = function () {
    var lines = this.state.lines, others = lines.filter(function (l) { return !l.fixed; }), fixed = [];
    if (this.base && others.length && !this.pickup()) {
      fixed.push({ id: 'fixed|base', card: 'fixed', kind: 'rental', name: this.base.name, unit: '', prefix: '', url: '', max: 1,
        variant: null, price: this.base.price, options: '', perso: '', qty: 1, fixed: true });
    }
    if (this.fee && others.length && this.pickup()) {
      fixed.push({ id: 'fixed|fee', card: 'fixed', kind: 'rental', name: this.fee.name, unit: '', prefix: '', url: '', max: 1,
        variant: null, price: this.fee.price, options: '', perso: '', qty: 1, fixed: true });
    }
    if (this.extraDay && others.length && this.state.event.days === '2') {
      fixed.push({ id: 'fixed|day2', card: 'fixed', kind: 'rental', name: this.extraDay.name, unit: '', prefix: '', url: '', max: 1,
        variant: null, price: this.extraDay.price, options: '', perso: '', qty: 1, fixed: true });
    }
    this.state.lines = fixed.concat(others);
  };

  // Formato de precio: siempre Intl ("150,00 €").
  Order.prototype.money = function (cents) {
    return this.fmt.format((cents || 0) / 100);
  };

  /* ---------- Tarjetas ---------- */

  Order.prototype.cardVariant = function (card) {
    var json = card.querySelector('[data-eo-variants]');
    if (!json) return null;
    if (!card._variants) { try { card._variants = JSON.parse(json.textContent); } catch (e) { card._variants = []; } }
    var picked = Array.prototype.map.call(card.querySelectorAll('[data-eo-option]'), function (s) { return s.value; });
    if (!picked.length) return card._variants[0] || null;
    for (var i = 0; i < card._variants.length; i++) {
      var v = card._variants[i];
      if (picked.every(function (val, idx) { return v.options[idx] === val; })) return v;
    }
    return null;
  };

  Order.prototype.syncCard = function (card) {
    if (card.getAttribute('data-kind') === 'buy') {
      var v = this.cardVariant(card);
      var priceEl = card.querySelector('[data-eo-price]');
      var stock = card.querySelector('[data-eo-stock]');
      var add = card.querySelector('[data-eo-add]');
      if (v) {
        card.setAttribute('data-variant', v.id);
        card.setAttribute('data-price', v.price);
        if (priceEl) priceEl.textContent = this.money(v.price);
      }
      var ok = !!(v && v.available);
      if (stock) stock.hidden = ok;
      if (add && !add.classList.contains('is-added')) { add.disabled = !ok; add.textContent = ok ? this.t.add : this.t.unavailable; }
    }
    var key = card.getAttribute('data-key');
    var qty = this.state.lines.filter(function (l) { return l.card === key; }).reduce(function (a, l) { return a + l.qty; }, 0);
    var inc = card.querySelector('[data-eo-incart]');
    if (inc) {
      inc.hidden = qty === 0;
      var t = inc.querySelector('[data-eo-incart-text]');
      if (t) t.textContent = qty === 1 ? this.t.in_order_one : this.t.in_order_other.replace('%n', qty);
    }
    card.classList.toggle('is-in-order', qty > 0);
  };

  Order.prototype.addFromCard = function (card) {
    var input = card.querySelector('[data-eo-qty]');
    var max = parseInt(card.getAttribute('data-max'), 10) || 999;
    var qty = Math.max(1, Math.min(max, parseInt(input && input.value, 10) || 1));
    var kind = card.getAttribute('data-kind');
    var cardKey = card.getAttribute('data-key');
    var rawPrice = card.getAttribute('data-price');
    var line = {
      card: cardKey,
      kind: kind,
      name: card.getAttribute('data-name'),
      unit: card.getAttribute('data-unit') || '',
      prefix: card.getAttribute('data-prefix') || '',
      url: card.getAttribute('data-url') || '',
      max: max,
      variant: card.getAttribute('data-variant') ? parseInt(card.getAttribute('data-variant'), 10) : null,
      price: rawPrice !== '' && rawPrice !== null ? parseInt(rawPrice, 10) : null,
      options: '',
      perso: ''
    };
    if (kind === 'buy') {
      var v = this.cardVariant(card);
      if (!v || !v.available) return;
      line.variant = v.id;
      line.price = v.price;
      line.options = card.querySelector('[data-eo-option]') ? v.title : '';
      var p = card.querySelector('[data-eo-perso]');
      line.perso = p ? p.value.trim() : '';
    }
    line.id = [cardKey, line.variant || '', line.perso].join('|');
    var existing = this.state.lines.filter(function (l) { return l.id === line.id; })[0];
    if (existing) existing.qty = Math.min(max, existing.qty + qty);
    else { line.qty = qty; this.state.lines.push(line); }
    var btn = card.querySelector('[data-eo-add]');
    if (btn) {
      var tr = this.t;
      btn.classList.add('is-added');
      btn.textContent = tr.added;
      window.setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = tr.add; }, 1400);
    }
    this.commit();
  };

  /* ---------- Resumen ---------- */

  Order.prototype.totals = function () {
    var r = { rental: 0, buy: 0, pending: false, count: 0, request: false, cart: false };
    this.state.lines.forEach(function (l) {
      if (!l.fixed) r.count += l.qty;
      if (l.price === null || isNaN(l.price)) r.pending = true;
      else r[l.kind === 'buy' ? 'buy' : 'rental'] += l.price * l.qty;
      if (l.kind === 'buy' || l.variant) r.cart = true;
      if (l.kind === 'rental' && !l.variant) r.request = true;
    });
    r.total = r.rental + r.buy;
    return r;
  };

  Order.prototype.lineLabel = function (l) {
    if (l.fixed) return l.name;
    var extra = [];
    if (l.options) extra.push(l.options);
    if (l.perso) extra.push(this.t.phrase + ': «' + l.perso + '»');
    extra.push(l.kind === 'buy' ? this.t.buy_lc : this.t.rental_lc);
    return l.name + ' (' + extra.join(' · ') + ')';
  };

  Order.prototype.priceLabel = function (l) {
    if (l.price === null || isNaN(l.price)) return this.t.on_request;
    return (l.prefix ? l.prefix + ' ' : '') + this.money(l.price);
  };

  Order.prototype.eventLine = function () {
    var e = this.state.event, parts = [];
    if (e.type) parts.push(e.type);
    if (e.date) {
      var d = new Date(e.date + 'T12:00:00');
      var ds;
      try { ds = d.toLocaleDateString(this.locale, { day: 'numeric', month: 'long', year: 'numeric' }); }
      catch (err) { ds = d.toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' }); }
      parts.push(isNaN(d) ? e.date : ds);
    }
    if (e.guests) parts.push(this.t.guests.replace('%n', e.guests));
    if (this.pickup()) parts.push(this.modePickup);
    if (this.extraDay && e.days === '2') parts.push(this.extraDay.name);
    return parts.join(' · ');
  };

  Order.prototype.linesText = function () {
    var self = this;
    var head = (this.modePickup && this.state.lines.length) ? [this.modeLabel(this.state.event.mode)] : [];
    return head.concat(this.state.lines.map(function (l) {
      var sub = (l.price === null || isNaN(l.price)) ? self.t.on_request_lc : self.money(l.price * l.qty);
      return l.qty + ' × ' + self.lineLabel(l) + ' — ' + self.priceLabel(l) + ' — ' + self.t.subtotal + ' ' + sub;
    })).join('\n');
  };

  Order.prototype.render = function () {
    var self = this, t = this.totals();
    var body = this.q('[data-eo-lines-body]');
    var has = this.state.lines.length > 0;
    this.q('[data-eo-empty]').hidden = has;
    this.q('[data-eo-table]').hidden = !has;
    this.q('[data-eo-totals]').hidden = !has;
    this.q('[data-eo-continue]').disabled = !has;
    body.innerHTML = '';
    this.state.lines.forEach(function (l, i) {
      var tr = document.createElement('tr');
      var sub = (l.price === null || isNaN(l.price)) ? self.t.on_request : self.money(l.price * l.qty);
      if (l.fixed) {
        tr.innerHTML =
          '<th scope="row"><span class="cv-eo-line__name"></span></th>' +
          '<td><span class="cv-eo-qty__val">1</span></td>' +
          '<td class="cv-eo-num"></td><td class="cv-eo-num cv-eo-line__sub"></td><td></td>';
        tr.querySelector('.cv-eo-line__name').textContent = l.name;
        tr.querySelector('.cv-eo-num').textContent = self.priceLabel(l);
        tr.querySelector('.cv-eo-line__sub').textContent = sub;
        body.appendChild(tr);
        return;
      }
      tr.innerHTML =
        '<th scope="row"><span class="cv-eo-line__name"></span><span class="cv-eo-line__meta"></span></th>' +
        '<td><div class="cv-eo-qty cv-eo-qty--sm"><button type="button" class="cv-eo-qty__btn" data-line-dec="' + i + '">−</button>' +
        '<span class="cv-eo-qty__val">' + l.qty + '</span>' +
        '<button type="button" class="cv-eo-qty__btn" data-line-inc="' + i + '">+</button></div></td>' +
        '<td class="cv-eo-num"></td><td class="cv-eo-num cv-eo-line__sub"></td>' +
        '<td><button type="button" class="cv-eo-x" data-line-del="' + i + '">×</button></td>';
      tr.querySelector('[data-line-dec]').setAttribute('aria-label', self.t.remove_one);
      tr.querySelector('[data-line-inc]').setAttribute('aria-label', self.t.add_one);
      tr.querySelector('[data-line-del]').setAttribute('aria-label', self.t.delete);
      tr.querySelector('.cv-eo-line__name').textContent = l.name;
      var meta = [l.kind === 'buy' ? self.t.buy : self.t.rental];
      if (l.options) meta.push(l.options);
      if (l.perso) meta.push('«' + l.perso + '»');
      tr.querySelector('.cv-eo-line__meta').textContent = meta.join(' · ');
      tr.querySelector('.cv-eo-num').textContent = self.priceLabel(l);
      tr.querySelector('.cv-eo-line__sub').textContent = sub;
      body.appendChild(tr);
    });
    this.q('[data-eo-sub="rental"]').textContent = this.money(t.rental);
    this.q('[data-eo-sub="buy"]').textContent = this.money(t.buy);
    this.q('[data-eo-row="rental"]').hidden = !this.state.lines.some(function (l) { return l.kind === 'rental'; });
    this.q('[data-eo-row="buy"]').hidden = !this.state.lines.some(function (l) { return l.kind === 'buy'; });
    this.q('[data-eo-total]').textContent = this.money(t.total) + (t.pending ? ' + ' + this.t.on_request_lc : '');
    this.q('[data-eo-pending]').hidden = !t.pending;
    var ev = this.eventLine();
    this.q('[data-eo-event-line]').textContent = ev || this.t.no_event;

    var bar = this.q('[data-eo-bar]');
    bar.hidden = !has;
    this.q('[data-eo-bar-total]').textContent = this.money(t.total) + (t.pending ? '+' : '');
    this.q('[data-eo-bar-count]').textContent = t.count;
    this.cards.forEach(function (c) { self.syncCard(c); });
    this.renderCheckout();
  };

  Order.prototype.renderCheckout = function () {
    var t = this.totals();
    var recap = this.q('[data-eo-recap]');
    if (recap) {
      recap.innerHTML = '';
      var ev = document.createElement('p');
      ev.className = 'cv-eo-recap__event';
      ev.textContent = this.eventLine() || this.t.fill_event;
      recap.appendChild(ev);
      if (this.state.lines.length) {
        var ul = document.createElement('ul');
        var self = this;
        this.state.lines.forEach(function (l) {
          var li = document.createElement('li');
          li.textContent = l.qty + ' × ' + self.lineLabel(l);
          ul.appendChild(li);
        });
        recap.appendChild(ul);
        var tot = document.createElement('p');
        tot.className = 'cv-eo-recap__total';
        tot.textContent = this.t.estimated_total + ' ' + this.money(t.total) + (t.pending ? ' ' + this.t.plus_on_request : '');
        recap.appendChild(tot);
      }
    }
    var form = this.q('#cv-eo-request-form');
    if (!form) return;
    form.classList.toggle('is-pay-only', !t.request && t.cart);
    this.q('[data-eo-send]').hidden = !t.request;
    this.q('[data-eo-send-note]').hidden = !t.request;
    this.q('[data-eo-pay]').hidden = t.request || !t.cart;
    this.q('[data-eo-pay-note]').hidden = !t.cart;
    this.q('[data-eo-send]').textContent = t.cart ? this.t.send_and_cart : this.t.send_booking;
    var lines = form.querySelector('[data-eo-lines]');
    if (lines) lines.value = this.linesText();
    var tf = form.querySelector('[data-eo-total-field]');
    if (tf) tf.value = this.money(t.total) + (t.pending ? ' ' + this.t.plus_on_request : '');
  };

  /* ---------- Evento ---------- */

  Order.prototype.syncEventFields = function () {
    var e = this.state.event, self = this;
    this.qa('[data-eo-field="type"]').forEach(function (r) { r.checked = r.value === e.type; });
    this.qa('[data-eo-field="days"]').forEach(function (r) { r.checked = r.value === (e.days || '1'); });
    this.qa('[data-eo-field="mode"]').forEach(function (r) { r.checked = r.value === (e.mode || 'service'); });
    this.qa('[data-eo-field="date"]').forEach(function (i) { if (document.activeElement !== i) i.value = e.date || ''; });
    this.qa('[data-eo-field="guests"]').forEach(function (i) { if (document.activeElement !== i) i.value = e.guests || ''; });
    this.qa('[data-eo-sync]').forEach(function (i) {
      var k = i.getAttribute('data-eo-sync');
      if (document.activeElement === i) return;
      i.value = (k === 'mode') ? self.modeLabel(e.mode) : (e[k] || '');
    });
  };

  Order.prototype.setEvent = function (k, v) {
    this.state.event[k] = v;
    this.commit();
  };

  Order.prototype.commit = function () {
    this.ensureBase();
    this.save();
    this.syncEventFields();
    this.render();
  };

  /* ---------- Carrito nativo ---------- */

  Order.prototype.cartItems = function () {
    var e = this.state.event, self = this;
    return this.state.lines.filter(function (l) { return !!l.variant; }).map(function (l) {
      var props = {};
      if (e.type) props['Evento'] = e.type;
      if (e.date) props['Fecha del evento'] = e.date;
      if (e.guests) props['Invitados'] = String(e.guests);
      if (l.kind === 'rental') props['Tipo'] = 'Alquiler';
      if (l.perso) props[self.persoProp] = l.perso;
      return { id: l.variant, quantity: l.qty, properties: props };
    });
  };

  Order.prototype.addToCart = function () {
    var items = this.cartItems(), errText = this.t.cart_error;
    if (!items.length) return Promise.resolve();
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || errText);
        return data;
      });
    });
  };

  Order.prototype.showMsg = function (text) {
    var m = this.q('[data-eo-msg]');
    if (!m) return;
    m.textContent = text || '';
    m.hidden = !text;
  };

  Order.prototype.validEvent = function () {
    var e = this.state.event;
    if (!e.type || !e.date) {
      var target = !e.type ? this.q('[data-eo-field="type"]') : this.q('[data-eo-field="date"]');
      var fs = this.q('.cv-eo-event');
      fs.classList.add('is-invalid');
      window.setTimeout(function () { fs.classList.remove('is-invalid'); }, 2400);
      this.closeSheet();
      fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (target) target.focus({ preventScroll: true });
      return false;
    }
    return true;
  };

  Order.prototype.goCheckout = function () {
    if (!this.state.lines.length || !this.validEvent()) return;
    var sec = this.q('[data-eo-checkout]');
    this.closeSheet();
    this.renderCheckout();
    sec.hidden = false;
    sec.classList.add('is-open');
    sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  /* ---------- Hoja móvil ---------- */

  Order.prototype.openSheet = function () {
    this.root.classList.add('is-sheet');
    var s = this.q('[data-eo-summary]');
    if (s) s.focus({ preventScroll: true });
  };
  Order.prototype.closeSheet = function () { this.root.classList.remove('is-sheet'); };

  /* ---------- Eventos ---------- */

  Order.prototype.init = function () {
    var self = this, root = this.root;

    // Tras enviar la solicitud: vaciar el pedido y recordar el pago si había compras.
    var posted = root.querySelector('[data-eo-posted="request"]');
    if (posted) {
      var hadCart = false;
      try { hadCart = window.sessionStorage.getItem(this.key + ':cart') === '1'; window.sessionStorage.removeItem(this.key + ':cart'); } catch (e) {}
      var rem = posted.querySelector('[data-eo-cart-reminder]');
      if (rem) rem.hidden = !hadCart;
      this.state.lines = [];
      this.save();
      this.q('[data-eo-checkout]').hidden = false;
    }
    var quote = this.q('[data-eo-quote]');
    if (quote && quote.querySelector('.cv-eo-done, .cv-eo-error')) quote.hidden = false;
    var req = this.q('#cv-eo-request-form');
    if (req && req.querySelector('.cv-eo-error')) this.q('[data-eo-checkout]').hidden = false;

    var today = new Date();
    var iso = new Date(today.getTime() - today.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
    this.qa('[data-eo-min-today]').forEach(function (i) { i.min = iso; });

    root.addEventListener('click', function (ev) {
      var t = ev.target.closest('button, a');
      if (!t || !root.contains(t)) return;
      var card = t.closest('[data-eo-item]');
      if (t.hasAttribute('data-eo-inc') || t.hasAttribute('data-eo-dec')) {
        var input = card.querySelector('[data-eo-qty]');
        var max = parseInt(card.getAttribute('data-max'), 10) || 999;
        var v = (parseInt(input.value, 10) || 1) + (t.hasAttribute('data-eo-inc') ? 1 : -1);
        input.value = Math.max(1, Math.min(max, v));
      } else if (t.hasAttribute('data-eo-add')) {
        self.addFromCard(card);
      } else if (t.hasAttribute('data-eo-remove')) {
        var k = card.getAttribute('data-key');
        self.state.lines = self.state.lines.filter(function (l) { return l.card !== k; });
        self.commit();
      } else if (t.hasAttribute('data-line-inc') || t.hasAttribute('data-line-dec')) {
        var i = parseInt(t.getAttribute('data-line-inc') || t.getAttribute('data-line-dec'), 10);
        var l = self.state.lines[i];
        if (!l || l.fixed) return;
        l.qty += t.hasAttribute('data-line-inc') ? 1 : -1;
        if (l.qty > (l.max || 999)) l.qty = l.max || 999;
        if (l.qty < 1) self.state.lines.splice(i, 1);
        self.commit();
      } else if (t.hasAttribute('data-line-del')) {
        var di = parseInt(t.getAttribute('data-line-del'), 10);
        if (self.state.lines[di] && self.state.lines[di].fixed) return;
        self.state.lines.splice(di, 1);
        self.commit();
      } else if (t.hasAttribute('data-eo-continue')) {
        self.goCheckout();
      } else if (t.hasAttribute('data-eo-open-sheet')) {
        self.openSheet();
      } else if (t.hasAttribute('data-eo-close-sheet')) {
        self.closeSheet();
      } else if (t.hasAttribute('data-eo-back')) {
        if (window.matchMedia('(max-width: 989px)').matches) self.openSheet();
        else self.q('[data-eo-summary]').scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else if (t.hasAttribute('data-eo-open-quote')) {
        var panel = self.q('[data-eo-quote]');
        panel.hidden = !panel.hidden;
        t.setAttribute('aria-expanded', String(!panel.hidden));
        var ta = panel.querySelector('[data-eo-lines]');
        if (ta && !ta.value && self.state.lines.length) {
          ta.value = self.state.lines.map(function (ln) { return ln.qty + ' × ' + self.lineLabel(ln); }).join('\n');
        }
        self.syncEventFields();
        if (!panel.hidden) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else if (t.hasAttribute('data-eo-pay')) {
        if (!self.validEvent()) return;
        t.disabled = true;
        t.textContent = self.t.preparing;
        self.showMsg('');
        self.addToCart().then(function () {
          self.state.lines = self.state.lines.filter(function (ln) { return !ln.variant; });
          self.save();
          window.location.href = ROOT + 'checkout';
        }).catch(function (err) {
          t.disabled = false;
          t.textContent = self.t.pay;
          self.showMsg(err.message);
        });
      }
    });

    root.addEventListener('change', function (ev) {
      var el = ev.target;
      if (el.matches('[data-eo-option]')) self.syncCard(el.closest('[data-eo-item]'));
      else if (el.matches('[data-eo-field="type"]')) self.setEvent('type', el.value);
      else if (el.matches('select[data-eo-sync="type"]')) self.setEvent('type', el.value);
      else if (el.matches('[data-eo-field="days"]')) self.setEvent('days', el.value);
      else if (el.matches('select[data-eo-sync="days"]')) self.setEvent('days', el.value);
      else if (el.matches('[data-eo-field="mode"]')) self.setEvent('mode', el.value);
      else if (el.matches('select[data-eo-sync="mode"]')) self.setEvent('mode', el.value === self.modePickup ? 'pickup' : 'service');
      else if (el.matches('[data-eo-qty]')) {
        var max = parseInt(el.getAttribute('max'), 10) || 999;
        el.value = Math.max(1, Math.min(max, parseInt(el.value, 10) || 1));
      }
    });

    root.addEventListener('input', function (ev) {
      var el = ev.target;
      if (el.matches('[data-eo-field="date"], [data-eo-sync="date"]')) self.setEvent('date', el.value);
      else if (el.matches('[data-eo-field="guests"], [data-eo-sync="guests"]')) self.setEvent('guests', el.value.replace(/[^0-9]/g, ''));
    });

    root.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && root.classList.contains('is-sheet')) self.closeSheet();
    });

    if (req) {
      req.addEventListener('submit', function (ev) {
        if (req._sending) return;
        if (!self.validEvent()) { ev.preventDefault(); return; }
        self.renderCheckout();
        var items = self.cartItems();
        if (!items.length) return;
        ev.preventDefault();
        var btn = self.q('[data-eo-send]');
        btn.disabled = true;
        self.showMsg('');
        self.addToCart().then(function () {
          try { window.sessionStorage.setItem(self.key + ':cart', '1'); } catch (e) {}
          req._sending = true;
          req.submit();
        }).catch(function (err) {
          btn.disabled = false;
          self.showMsg(err.message);
        });
      });
    }

    // Barra móvil: se oculta cuando el resumen ya está a la vista.
    var summary = this.q('[data-eo-summary]');
    if ('IntersectionObserver' in window && summary) {
      new IntersectionObserver(function (entries) {
        root.classList.toggle('is-summary-visible', entries[0].isIntersecting && !root.classList.contains('is-sheet'));
      }, { threshold: 0.15 }).observe(summary);
    }

    // Volver atrás (caché del navegador): recuperar el pedido guardado.
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) { self.state = self.load(); self.closeSheet(); self.commit(); }
    });

    this.commit();
  };

  function boot() {
    document.querySelectorAll('[data-cv-eo]').forEach(function (el) {
      if (!el._cvOrder) el._cvOrder = new Order(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();